import React from "react";
const NewsItemSkeleton = ({id}) => {
  return (
    <div className="card mb-3 news-item-card shadow" id ={id}>
      <div className="card-body">

        <p
          className="card-date text-muted shimmer"
          style={{ height: "15px", width: "30%", marginBottom: "10px" }}
        ></p>
        <div className="shimmer" style={{ height: "15px", width: "50%" }}></div>
      </div>
    </div>
  );
};

export default NewsItemSkeleton;
